import { Badge as BadgeMantine, BadgeProps } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { IColor, variantColors } from "../../../../utils/selectColors";

interface IProps extends BadgeProps {
  value: string;
}

export default function TagValue({ value, ...props }: IProps) {
  const selectedVariant = variantColors[IColor.babyBlue];
  const { t } = useTranslation();
  return (
    <BadgeMantine
      styles={{
        root: {
          background: selectedVariant.bg,
          padding: "4px 8px",
          height: "30px",
          fontSize: "16px",
          border: "1.5px solid",
          width: "fit-content",
          borderRadius: "20px",
          borderColor: selectedVariant.borderColor,
        },
      }}
      radius="sm"
      {...props}
    >
      <span style={{ color: selectedVariant.color }}>{value}</span>
    </BadgeMantine>
  );
}
